import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";

import clsx from "clsx";

import { makeStyles, Paper, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import ContactDrawer from "../ContactDrawer";
import MessageInput from "../MessageInput/";
import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";
import TicketActionButtons from "../TicketActionButtonsCustom";
import MessagesList from "../MessagesList";
import api from "../../services/api";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageProvider } from "../../context/ForwarMessage/ForwardMessageContext";

import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TagsContainer } from "../TagsContainer";
import { isNil } from 'lodash';
import { EditMessageProvider } from "../../context/EditingMessage/EditingMessageContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { i18n } from "../../translate/i18n";
import ConfirmationModal from "../ConfirmationModal";

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },
  // ... (omitting styles for brevity, assuming tool keeps them if I map correctly)
  // Wait, replace_file_content replaces the WHOLE BLOCK. I need to be careful.
  // I will just remove the imports from line 88 and add them to line 24.


  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "0",
    backgroundColor: "transparent", // Make sure wrapper shadow is visible
    border: "none",
    marginRight: -drawerWidth,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
  },

  statusBanner: {
    width: "100%",
    padding: "4px 0",
    textAlign: "center",
    color: "white",
    fontWeight: "bold",
    fontSize: "0.8rem",
    fontFamily: "'Inter', 'Roboto', sans-serif !important",
    transition: "all 0.5s ease",
    zIndex: 1,
  },
  bannerOn: {
    backgroundColor: "#4caf50", // Verde
    boxShadow: "inset 0px 0px 10px rgba(0,0,0,0.1)"
  },
  bannerOff: {
    backgroundColor: "#f44336", // Rojo
    boxShadow: "inset 0px 0px 10px rgba(0,0,0,0.1)"
  },

  mainWrapperShift: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
  },
}));

const Ticket = () => {
  const { ticketId } = useParams();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles();

  const { user, socket } = useContext(AuthContext);
  const { setTabOpen } = useContext(TicketsContext);


  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});
  const [dragDropFiles, setDragDropFiles] = useState([]);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { companyId } = user;

  // [ANTIGRAVITY] Toggle Integration Logic
  const handleToggleIntegration = async (overrideStatus = false) => {
    try {
      const payload = {
        useIntegration: !ticket.useIntegration
      };

      if (overrideStatus) {
        payload.status = "pending";
        payload.isBot = true;
      }

      await api.put(`/tickets/${ticket.id}`, payload);
      // Socket triggers update
    } catch (err) {
      toastError(err);
    }
  };

  const handleToggleCheck = () => {
    // Si quiere encender (actualmente apagado) Y el ticket está OPEN
    if (!ticket.useIntegration && ticket.status === "open") {
      setConfirmationOpen(true);
    } else {
      handleToggleIntegration();
    }
  };

  useEffect(() => {
    setLoading(true);
    // ... (rest of useEffect logic remains same, just ensuring imports are correct)
    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {

          if (!isNil(ticketId) && ticketId !== "undefined") {

            const { data } = await api.get("/tickets/u/" + ticketId);

            setContact(data.contact);
            // setWhatsapp(data.whatsapp);
            // setQueueId(data.queueId);
            setTicket(data);

            // Verificar se há parâmetro 'tab' na URL - TEM PRIORIDADE ABSOLUTA
            const urlParams = new URLSearchParams(window.location.search);
            const tabParam = urlParams.get('tab');

            // Se houver parâmetro tab na URL, usar ele SEMPRE (tem prioridade absoluta)
            // NÃO usar o status do ticket se houver parâmetro na URL
            if (tabParam && ["pending", "open", "group", "closed"].includes(tabParam)) {
              // Usar setTimeout para garantir que seja aplicado depois que o TicketsManagerTabs carregar
              // E usar um delay maior para garantir que o TicketsManagerTabs já processou o parâmetro
              setTimeout(() => {
                setTabOpen(tabParam);
              }, 200);
            } else {
              // Só usar o status do ticket se NÃO houver parâmetro na URL
              // E apenas se o status for válido
              if (["pending", "open", "group"].includes(data.status) || data.isGroup) {
                setTimeout(() => {
                  setTabOpen(data.isGroup ? "group" : data.status);
                }, 200);
              }
            }
            setLoading(false);
          }
        } catch (err) {
          history.push("/tickets");   // correção para evitar tela branca uuid não encontrado Feito por Altemir 16/08/2023
          setLoading(false);
          toastError(err);
        }
      };
      fetchTicket();
    }, 0);

    return () => clearTimeout(delayDebounceFn);
  }, [ticketId, user, history]);

  useEffect(() => {
    if (!ticket && !ticket.id && ticket.uuid !== ticketId && ticketId === "undefined") {
      return;
    }

    if (user.companyId) {
      //    const socket = socketManager.GetSocket();

      const onConnectTicket = () => {
        socket.emit("joinChatBox", `${ticket.id}`);
      }

      const onCompanyTicket = (data) => {
        if (data.action === "update" && data.ticket.id === ticket?.id) {
          setTicket(data.ticket);
        }

        if (data.action === "delete" && data.ticketId === ticket?.id) {
          history.push("/tickets");
        }
      };

      const onCompanyContactTicket = (data) => {
        if (data.action === "update") {
          // if (isMounted) {
          setContact((prevState) => {
            if (prevState.id === data.contact?.id) {
              return { ...prevState, ...data.contact };
            }
            return prevState;
          });
          // }
        }
      };

      socket.on("connect", onConnectTicket)
      socket.on(`company-${companyId}-ticket`, onCompanyTicket);
      socket.on(`company-${companyId}-contact`, onCompanyContactTicket);

      return () => {

        socket.emit("joinChatBoxLeave", `${ticket.id}`);
        socket.off("connect", onConnectTicket);
        socket.off(`company-${companyId}-ticket`, onCompanyTicket);
        socket.off(`company-${companyId}-contact`, onCompanyContactTicket);
      };
    }
  }, [ticketId, ticket, history]);

  const handleDrawerOpen = useCallback(() => {
    setDrawerOpen(true);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);

  const handleQuickMessageSelect = (quickMessage) => {
    try {
      if (quickMessage.message) {
        // Disparar evento que o MessageInput vai escutar
        const event = new CustomEvent('insertQuickMessage', {
          detail: { quickMessage }
        });
        window.dispatchEvent(event);

      }

      if (quickMessage.mediaPath) {
        // Tratar mídia se necessário
      }
    } catch (error) {
      console.error("Erro ao inserir resposta rápida:", error);
      toastError("Erro ao inserir resposta rápida");
    }
  };

  const renderMessagesList = () => {
    return (
      <>
        <MessagesList
          isGroup={ticket.isGroup}
          onDrop={setDragDropFiles}
          whatsappId={ticket.whatsappId}
          queueId={ticket.queueId}
          channel={ticket.channel}
          isCTWA={!!(ticket.dataWebhook && ticket.dataWebhook.ctwa)}
          ticketStatus={ticket.status}
        >
        </MessagesList>
        <MessageInput
          ticketId={ticket.id}
          ticketStatus={ticket.status}
          ticketChannel={ticket.channel}
          droppedFiles={dragDropFiles}
          contactId={contact.id}
          whatsappId={ticket.whatsappId}
          ticket={ticket}
        />
      </>
    );
  };


  return (
    <div className={classes.root} id="drawer-container">
      <ConfirmationModal
        title={i18n.t("triggerFlowModal.confirmation.title") || "Cambio de Estado Requerido"}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={() => {
          setConfirmationOpen(false);
          handleToggleIntegration(true);
        }}
      >
        {i18n.t("triggerFlowModal.confirmation.message") || "El Ticket se encuentra en estado Abierto. Para activar las implementaciones se cambiará a estado Pendiente. ¿Deseas continuar?"}
      </ConfirmationModal>

      <Paper
        elevation={0}
        style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
        className={clsx(classes.mainWrapper, {
          [classes.mainWrapperShift]: drawerOpen && !isMobile,
        })}
      >
        {/* <div id="TicketHeader"> */}
        <TicketHeader loading={loading}>
          {ticket.contact !== undefined && (
            <div id="TicketHeader">
              <TicketInfo
                contact={contact}
                ticket={ticket}
                onClick={handleDrawerOpen}
              />
            </div>
          )}
          <TicketActionButtons
            ticket={ticket}
            contact={contact}
            onQuickMessageSelect={handleQuickMessageSelect}
          />
        </TicketHeader>

        {ticket.id && !loading && !["closed", "ignored"].includes(ticket.status) && (
          <div
            className={clsx(classes.statusBanner, ticket.useIntegration ? classes.bannerOn : classes.bannerOff)}
            onClick={handleToggleCheck}
            style={{ cursor: 'pointer' }}
            title={i18n.t("tickets.implementationsTooltip") || "Haga clic para encender/apagar y reiniciar memoria de la IA"}
          >
            {ticket.useIntegration ? (i18n.t("tickets.implementationsOnBanner") || "Implementaciones Encendidas (Clic para Apagar)") : (i18n.t("tickets.implementationsOffBanner") || "Implementaciones Apagadas (Clic para Encender)")}
          </div>
        )}

        {/* </div> */}
        <div style={{ padding: '10px 15px', backgroundColor: theme.palette.background.default, zIndex: 0, position: 'relative' }}>
          <TagsContainer contact={contact} />
        </div>
        <ReplyMessageProvider>
          <ForwardMessageProvider>
            <EditMessageProvider>
              {renderMessagesList()}
            </EditMessageProvider>
          </ForwardMessageProvider>
        </ReplyMessageProvider>
      </Paper>

      <ContactDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        contact={contact}
        loading={loading}
        ticket={ticket}
      />

    </div>
  );
};

export default Ticket;
